import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Form from "../forms/Form";
import FormInput from "../forms/FormInput";

import modalStyles from "./Modal.module.scss";

type FormProps = {
  setName: (value: string) => void;
  setEmail: (value: string) => void;
  setSchool?: (value: string) => void;
  setCourse?: (value: string) => void;
  schoolOptions?: [string, string][] | [];
  courseOptions?: [string, string][] | [];
  isManager: boolean;
};

export const JikeiAddUserForm: React.FC<FormProps> = ({
  setName,
  setEmail,
  setSchool,
  setCourse,
  schoolOptions,
  courseOptions,
  isManager,
}) => {
  return (
    <Form
      handler={() => {}}
      className={modalStyles["f-modal__wrapper-content__form"]}
    >
      <p className={modalStyles["f-modal__wrapper-content__form-desc"]}>
        追加したい{isManager === true ? "管理者" : "学生"}
        の情報を入力してください。
        <br />
        登録案内のメールが送信されます。
      </p>
      <div className={modalStyles["f-modal__wrapper-content__form-label"]}>
        {isManager === true ? "管理者" : "学生"}氏名
      </div>
      <FormInput
        handler={(value) => {
          if (value !== undefined && typeof value === "string") {
            setName(value);
          }
        }}
        type="text"
        label=""
        name="name"
        style_class={modalStyles["f-modal__wrapper-content__form-input"]}
        placeholder={`${isManager === true ? "管理者" : "学生"}氏名を入力`}
      />
      <div className={modalStyles["f-modal__wrapper-content__form-label"]}>
        メールアドレス
      </div>
      <FormInput
        handler={(value) => {
          if (value !== undefined && typeof value === "string") {
            setEmail(value);
          }
        }}
        type="text"
        label=""
        name="mail"
        style_class={modalStyles["f-modal__wrapper-content__form-input"]}
        placeholder="xxxxxxxxxxxxxxxx@domain.com"
      />
      {setSchool !== undefined ? (
        <>
          <div className={modalStyles["f-modal__wrapper-content__form-label"]}>
            所属校
          </div>
          <div className={modalStyles["f-modal__wrapper-content__form-parent"]}>
            <FormInput
              handler={(value) => {
                if (value !== undefined && typeof value === "string") {
                  setSchool(value !== "選択してください" ? value : "");
                }
              }}
              type="select"
              label=""
              name="school"
              options={schoolOptions}
              select_class={modalStyles["f-modal__wrapper-content__form-input"]}
              holder_class={
                modalStyles["f-modal__wrapper-content__form-holder"]
              }
              placeholder="選択してください"
            />
            <FontAwesomeIcon icon={["fal", "chevron-down"]} />
          </div>
        </>
      ) : null}

      {setCourse !== undefined ? (
        <>
          <div className={modalStyles["f-modal__wrapper-content__form-label"]}>
            コース
          </div>
          <div className={modalStyles["f-modal__wrapper-content__form-parent"]}>
            <FormInput
              handler={(value) => {
                if (value !== undefined && typeof value === "string") {
                  setCourse(value !== "選択してください" ? value : "");
                }
              }}
              type="select"
              label=""
              name="course"
              options={courseOptions}
              select_class={modalStyles["f-modal__wrapper-content__form-input"]}
              holder_class={
                modalStyles["f-modal__wrapper-content__form-holder"]
              }
              placeholder="選択してください"
            />
            <FontAwesomeIcon icon={["fal", "chevron-down"]} />
          </div>
        </>
      ) : null}
    </Form>
  );
};
